// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d04a18d5","455":"ea9635ba","977":"85a4cf9b"}[chunkId] + ".chunk.js";
};